const faNums = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
const faDigitsRegex = /[۰۱۲۳۴۵۶۷۸۹]/g;

const cachedNumberFormatterInstances = {
  [`en-US-${JSON.stringify({})}`]: new Intl.NumberFormat('en-US', {}),
};

function numberFormatter(number: number, locale = 'en-US', configs = {}) {
  const instanceKey = `${locale}-${JSON.stringify(configs)}`;
  let formatterInstance = cachedNumberFormatterInstances[instanceKey];

  if (!formatterInstance) {
    const newInstance = new Intl.NumberFormat(locale, configs);

    cachedNumberFormatterInstances[instanceKey] = newInstance;
    formatterInstance = newInstance;
  }

  let formatted = formatterInstance.format(number);

  // Strip sign only when the formatted result represents zero
  if (
    /^[+-]?0(\.0*)?$/.test(
      formatted.replace(/[^\d.,+-]/g, '').replace(',', '.')
    )
  ) {
    formatted = formatted.replace(/^[+-]/, '');
  }

  return formatted;
}

const convertFaDigitsToEn = (value: string) => {
  return String(value).replace(
    faDigitsRegex,
    (char) => `${faNums.indexOf(char)}`
  );
};

export { numberFormatter, convertFaDigitsToEn };
